import mockFeatureRequestsData from "../../data/mockData/featureRequestsData";
import { types } from "./action";

const initialState = {
  seed: mockFeatureRequestsData,
  tableRowResults: [],
  created: [],
};

function upsertById(rows, row) {
  if (!row || row.id == null) {
    return rows;
  }
  const sid = String(row.id);
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    const next = [...rows];
    next[idx] = { ...next[idx], ...row };
    return next;
  }
  return [...rows, row];
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FEATURE_REQUESTS:
      return {
        ...state,
        tableRowResults: Array.isArray(action.payload) ? action.payload : state.tableRowResults,
      };
    case types.ADD_FEATURE_REQUEST: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      const exists = state.created.some(r => String(r.id) === String(row.id));
      if (exists) {
        return state;
      }
      return {
        ...state,
        created: [...state.created, row],
      };
    }
    case types.UPDATE_FEATURE_REQUEST: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      return {
        ...state,
        created: upsertById(state.created, row),
      };
    }
    case types.DELETE_FEATURE_REQUEST: {
      const id = action.payload;
      if (id == null) {
        return state;
      }
      const sid = String(id);
      return {
        ...state,
        created: state.created.filter(r => String(r.id) !== sid),
        tableRowResults: state.tableRowResults.filter(r => String(r.id) !== sid),
      };
    }
    default:
      return state;
  }
};
